import { render, staticRenderFns } from "./ChangeDisplayCategory.vue?vue&type=template&id=15e2d809&scoped=true&"
import script from "./ChangeDisplayCategory.vue?vue&type=script&lang=ts&"
export * from "./ChangeDisplayCategory.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeDisplayCategory.vue?vue&type=style&index=0&id=15e2d809&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2d809",
  null
  
)

export default component.exports